import { useCallback } from 'react';

import { UPSERT_ACTION_RESOURCE } from 'src/graphql/cap/mutation';
import { useMutation } from 'src/graphql';

export default () => {
  const [upsertActionResource] = useMutation(UPSERT_ACTION_RESOURCE);

  return useCallback(
    payload => upsertActionResource({ variables: { ...payload }, }),
    [],
  );
};
